package kz.dentalcrm.app.screens.treatment.add.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TemplateItem
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TreatmentDetailResponseItem

data class AddPatientTreatmentState(
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val appointmentId: Int = 0,
    val selectedTeeth: List<String> = emptyList(),
    val templates: PersistentList<TemplateItem> = persistentListOf(),
    val diagnoses: PersistentList<Diagnosis> = persistentListOf(),
    val selectedTemplate: TemplateItem? = null,
    val selectedDiagnosis: Diagnosis? = null,
    val templateDetails: PersistentList<TreatmentDetailResponseItem> = persistentListOf(),
    val selectedOptions: Map<Int, List<Int>> = emptyMap(), // Changed to List to support multiple choice
    val customValues: Map<Int, String> = emptyMap(),
    val enableSave: Boolean = false
)

sealed interface AddPatientTreatmentEvent : ViewEvent {
    data class LoadData(val appointmentId: Int, val initialTeeth: List<String>) : AddPatientTreatmentEvent
    data class ToggleTooth(val toothId: String) : AddPatientTreatmentEvent
    data class SelectTemplate(val template: TemplateItem) : AddPatientTreatmentEvent
    data class SelectDiagnosis(val diagnosis: Diagnosis) : AddPatientTreatmentEvent
    data class SelectOption(val typeId: Int, val optionId: Int) : AddPatientTreatmentEvent
    data class UpdateCustomValue(val typeId: Int, val value: String) : AddPatientTreatmentEvent
    data object Save : AddPatientTreatmentEvent
    data object OnBack : AddPatientTreatmentEvent
}

sealed interface AddPatientTreatmentSideEffect : ViewSideEffect {
    data object NavigateBack : AddPatientTreatmentSideEffect
    data class ShowError(val message: String) : AddPatientTreatmentSideEffect
}
